/**
 * 文件名编码解码工具函数
 */

/**
 * 安全解码文件名
 * @param {string} encodedFileName - 编码后的文件名
 * @returns {string} 解码后的文件名
 */
export const safeDecodeFileName = (encodedFileName) => {
  if (!encodedFileName) return '';
  
  try {
    // 尝试解码
    const decoded = decodeURIComponent(encodedFileName);
    
    // 检查解码后是否还包含编码字符（如%20等），如果有则可能需要多次解码
    if (decoded.includes('%') && decoded !== encodedFileName) {
      return safeDecodeFileName(decoded);
    }
    
    return decoded;
  } catch (error) {
    // 如果解码失败，返回原始文件名
    console.warn('文件名解码失败:', encodedFileName, error.message);
    return encodedFileName;
  }
};

/**
 * 安全编码文件名
 * @param {string} fileName - 原始文件名
 * @returns {string} 编码后的文件名
 */
export const safeEncodeFileName = (fileName) => {
  if (!fileName) return '';
  
  try {
    return encodeURIComponent(fileName);
  } catch (error) {
    console.warn('文件名编码失败:', fileName, error.message);
    return fileName;
  }
};

/**
 * 检查文件名是否已编码
 * @param {string} fileName - 文件名
 * @returns {boolean} 是否已编码
 */
export const isFileNameEncoded = (fileName) => {
  if (!fileName) return false;
  
  try {
    const decoded = decodeURIComponent(fileName);
    return decoded !== fileName;
  } catch (error) {
    return false;
  }
};

/**
 * 去除文件名后缀
 * @param {string} fileName - 文件名
 * @returns {string} 不含后缀的文件名
 */
export const getFileNameWithoutExtension = (fileName) => {
  if (!fileName) return '';
  return fileName.replace(/\.[^.]+$/, '');
}; 